<div class="col1Pane h-100" [class.dontShowDevices]="!showDeviceButtons">
	@if (showDeviceButtons) {
		<div class="deviceButtons">
			@for (deviceId of deviceIds; track TrackByMethods.trackByClientId(participantIndex, deviceId); let participantIndex = $index) {
				<div
					[class]="'deviceButton'"
					[class.isRecorder]="sessionClientData[deviceId.clientId].clientType === WebClientType.Recorder"
				>
					<button
						[style.background-color]="userData[deviceId.userId].color"
						class="large"
						mat-fab
						#target
						[matTooltip]="WebClientType[sessionClientData[deviceId.clientId].clientType]"
						matTooltipClass="accent"
					>
						@switch (sessionClientData[deviceId.clientId].clientType) {
							@case (WebClientType.Recorder) {
								<mat-icon inline fontSet="fad" fontIcon="fa-record-vinyl" />
							}
							@case (WebClientType.ViewingStation) {
								<mat-icon inline fontSet="fad" fontIcon="fa-tv" />
							}
							@case (WebClientType.Tablet) {
								<mat-icon inline fontSet="fad" fontIcon="fa-tablet" />
							}
						}
					</button>
				</div>
			}
		</div>
	}
	<div class="actionButtons">
		<ng-content select="[additionalActionButtons]" />

		@if (showStageDesignerButton) {
			<button
				[disabled]="!stageDesignerButtonActive"
				mat-fab
				class="large"
				(click)="openStageDesigner()"
				matTooltip="{{ T.SHARED_SIDE_ACTION_BAR_OPEN_STAGE_DESIGNER | translate }}"
				matTooltipClass="accent"
			>
				<mat-icon fontSet="fas" fontIcon="fa-layer-group" style="font-size: 1.4em" inline />
			</button>
		}
		@if (showEditButton) {
			<button
				[disabled]="!editButtonEnabled"
				mat-fab
				class="large"
				(click)="editButtonClickedEmit()"
				matTooltip="{{ T.SHARED_SIDE_ACTION_BAR | translate }}"
				matTooltipClass="accent"
			>
				<mat-icon fontSet="fas" fontIcon="fa-pen" style="font-size: 1.4em" inline />
			</button>
		}
		<button
			mat-fab
			class="large"
			matTooltip="{{ T.SHARED_SIDE_ACTION_BAR_LEAVE_APPLICATION_NAME | translate }}"
			matTooltipClass="accent"
			(click)="leaveApplication()"
		>
			<mat-icon fontSet="fas" fontIcon="fa-door-open" style="font-size: 1.4em" inline />
		</button>
		@if (showDeleteButton) {
			<button
				mat-fab
				class="large"
				color="warn"
				matTooltip="{{ T.SHARED_EVENT_CONTAINER_DELETE_EVENT | translate }}"
				matTooltipClass="warn"
				(click)="deleteEvent()"
			>
				<mat-icon fontSet="fad" fontIcon="fa-trash-alt" style="font-size: 1.4em" inline />
			</button>
		}
	</div>
</div>
